import React from 'react';

const TestPage = () => {
  console.log('TestPage is rendering');
  
  return (
    <div className="min-h-screen bg-red-500 flex items-center justify-center">
      <div className="text-white text-4xl font-bold text-center">
        <div>Test Page - If you see this, React is working!</div>
        <div className="text-2xl mt-4">Check browser console for logs</div>
      </div>
    </div>
  );
};

export default TestPage;
